<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      per-page="1000"
      :headers="_headers"
      :items="list ? list.connectors : []"
      selected-product="cso"
      :product-options="productOptions"
      show-date
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:charge_point_id="{ item }">
        <div class="d-flex align-center">
          <StatusBadge :status="item.connectivity_status" />
          {{ item.charge_point_id }} / {{ item?.connector_id }}
        </div>
      </template>

      <template v-slot:actions="{ item }">
        <v-icon
          class="mr-2"
          small
          @click="openOcppModal(item)"
        >
          mdi-information
        </v-icon>
        <!-- <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon> -->
        <!-- <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon> -->
        <!-- <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon> -->
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <!-- <create-charge-stations
            v-if="isCreate"
            :filter-options="options"
          /> -->

          <!-- <edit-charge-stations
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          /> -->
          <!-- <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          /> -->
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    // CreateChargeStations: () => import("./dialogs/CreateChargeStations.vue"),
    // EditChargeStations: () => import("./dialogs/EditChargeStations.vue"),
    // ConfirmationModal: () =>
    //   import("@/components/Modals/ConfirmationModal.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    refreshButton: () =>
      import("../../../../components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "downtime-list.view",
        create: "downtime-list.create",
        edit: "downtime-list.edit",
        delete: "downtime-list.delete",
      },
      filters: {},
      subFilters: {},
      //
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargeStations/getLoading",
      meta: "csmsChargeStations/getMeta",
      list: "csmsDashboard/getChargerAvailability",
    }),
    _headers() {
      const headers = [
        // {
        //   text: this.$t("id"),
        //   align: "left",
        //   sortable: true,
        //   value: "id",
        // },
        {
          text: this.$t("connector_id"),
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        // {
        //   text: this.$t("tenant_name"),
        //   align: "left",
        //   sortable: false,
        //   value: "tenant_name",
        //   showAdmin: true,
        // },
        // {
        //   text: this.$t("charge_stations"),
        //   align: "left",
        //   sortable: false,
        //   value: "station_name",
        // },

        {
          text: "Availability Percent",
          align: "left",
          sortable: false,
          value: "availability_percent",
        },

        {
          text: "Downtime (seconds)",
          align: "center",
          sortable: false,
          value: "tq_seconds",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
    copyText() {
      return (
        "Charge Station OCPP ID: " +
        this.integrationInfo.charge_point_id +
        "  OCPP Connection URL:  " +
        this.integrationInfo.ocpp_connection_url
      );
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "downtime_list",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("csmsDashboard/chargerAvailability", params);

      // await this.$store.dispatch("csmsDashboard/chargerAvailability", params).then(() => {
      //   if (this.options.page > (this.meta?.lastPage || 1)) {
      //     this.options.page = 1;
      //   }
      // });
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
